export const env_pro = {
    BASE_URL: 'https://equipajes-api.europ.es',
    NODE_ENV: 'production',
}